module.exports = __webpack_public_path__ + "static/img/1_1_3_2.4d33e7de.jpg";